import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { Subscription } from 'rxjs';

import { NavigationService, NavLink } from './navigation.service';


@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    standalone: false
})
export class NavComponent implements OnInit, OnDestroy {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly navigationService = inject(NavigationService);

  private readonly subcription: Subscription = new Subscription();
  links: NavLink[] = [];

  ngOnDestroy() {
    this.subcription.unsubscribe();
  }

  ngOnInit() {
    this.handleSizeChange();
    this.subcription.add(this.breakpointObserver.observe([Breakpoints.Handset,
    Breakpoints.Tablet, Breakpoints.Web]).subscribe(result => {
      if (result.matches) {
        this.handleSizeChange();
      }
    }));

    this.subcription.add(this.navigationService.getLinks().subscribe(
      l => {
        this.links = l;
      }
    ));
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private handleSizeChange() {
  }
}

